<template>
  <div class="login">
    <h3>Authentification :</h3>
    <input v-model="email" type="text" placeholder="Entrez l'email" />
    <br />
    <input v-model="password" type="password" placeholder="Entrez le mot de passe" />
    <br />
    <button @click="checkLogin" type="button">OK</button>
    <div v-if="isLoading">
      <span>Connexion en cours...</span>
    </div>
    <div v-if="isPasswordWrong">
      <span class="wrong_password">Erreur : mot de passe erroné</span>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      isPasswordWrong: false,
      isLoading: false,
    };
  },
  methods: {
    checkLogin: function() {
      this.isLoading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          this.$router.replace('/News');
        })
        .catch(err => {
          this.isPasswordWrong = true;
          this.isLoading = false;

          setTimeout(() => {
            this.isPasswordWrong = false;
          }, 2000);
        });
    },
  },
};
</script>

<style lang="scss">
.login {
  .wrong_password {
    color: red;
    margin-left: 16px;
  }
}
</style>